export const DRAWER_WIDTH = 124;
